<template>
  <div>
    <div class="">
      Para anular este proceso de aprobación debes realizarlo
      bajo la seguridad del 2FA o Cód. de verificación
    </div>
    <div class="wrap-option">
      <vs-radio
      data-cy="2FA-(OTP)"
      v-model="cancel.typeCancel"
      vs-value="twoFa">2FA (OTP)
      </vs-radio>
      <vs-radio
        v-model="cancel.typeCancel"
        vs-value="internCode"
      >
        Código de Verificación
      </vs-radio>
    </div>
    <div v-if="cancel.typeCancel === 'internCode'" class="wrap-form">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <b-button
            :disabled="gettingCode"
            size="sm"
            variant="primary"
            v-on:click="getCode()"
          >
            Solicitar código
          </b-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-input
            maxlength = "8"
            label="Código de Verificación"
            v-model="cancel.code"
            data-cy="cancel-code"
          />
        </vs-col>
      </vs-row>
    </div>
    <div v-if="cancel.typeCancel === 'twoFa'" class="wrap-form">
      <vs-input
        data-cy="otp-code"
        maxlength = "8"
        label="Código de Verificación"
        v-model="cancel.code"
      />
    </div>
    <div
      v-if="error.message !== ''"
      class="con-text-validation span-text-validation-danger
          vs-input--text-validation-span v-enter-to text-right"
      style="height: 32px;"
    >
        <span class="span-text-validation">
          {{error.message}}
        </span>
    </div>
    <div class="mt-4 text-center">
      <b-button
        data-cy="override-process"
        variant="primary"
        v-on:click="cancelFile()"
      >
        Anular Proceso
      </b-button>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  components: {

  },
  data() {
    return {
      gettingCode: false,
      error: {
        message: ''
      },
      cancel: {
        typeCancel: 'internCode'
      }
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'groupsCompany'
    ]),
    ...mapGetters('Usuario', [
      'verificationCode',
      'loading'
    ]),
  },
  methods: {
    ...mapActions('Approvals', [
      'attemptCancelFile'
    ]),
    ...mapActions('Usuario', [
      'getVerificationCode'
    ]),
    cancelProcess() {},
    async getCode() {
      this.gettingCode = true;
      await this.getVerificationCode(
        { motivo: `Verificación para anular expediente Nº: ${this.file.numero}` }
      );
      this.$bvToast.toast(
        'El código de verificación llegará en unos instantes a tu correo',
        {
          title: '¡Hey!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 4000
        }
      );
      this.gettingCode = false;
    },
    async cancelFile() {
      if (this.cancel.typeCancel === 'internCode' && !this.cancel.code) {
        this.error.message = 'Oops! Debes ingresar un código de verificación';
        return;
      }
      if (this.cancel.typeCancel !== 'internCode' && !this.cancel.code) {
        this.error.message = 'Oops! Debes ingresar un código OTP';
        return;
      }
      this.error.message = '';
      const cancel = {
        ejecucionId: this.file.id,
        aprobacionId: this.file.id
      };

      if (this.cancel.typeCancel === 'internCode') {
        cancel.codigo = this.cancel.code;
        cancel.idExterno = this.verificationCode;
      } else {
        cancel.otp = this.cancel.code;
      }

      await this.attemptCancelFile({ cancel, idAprobacion: this.file.idAprobacion });
      this.$emit('close');
      await this.$bvToast.toast(
        `Se ha anulado el proceso de aprobación para el documento ${this.file.numero}`,
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      this.cancel.code = '';
      this.cancel.typeCancel = 'internCode';
    }
  },
  props: {
    file: { type: Object, required: true }
  }
};
</script>
<style scoped>

.wrap-option {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.wrap-form {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}
</style>
